import { Component, OnInit } from '@angular/core'
import {Router} from '@angular/router';
import {RolService} from 'src/app/services/rol.service';

@Component ({
  selector: 'deteccion-fraude-boton-aprobar-caso',
  templateUrl: './boton-aprobar-caso.component.html',
  styleUrls: ['./boton-aprobar-caso.component.scss']
})
export class DeteccionFraudesBotonAprobarCasoComponent implements OnInit {
  boton: boolean = this.rolService.permisos.toString().includes('Supervisor Gestión de Fraudes') ||
    this.rolService.permisos.toString().includes('Gerente Gestión de Fraudes') ? true : false
  permisosStr: string = ''
  constructor(
    public router: Router,
    public rolService: RolService,
  ){}
  ngOnInit(){}
  verification(){
    this.permisosStr = this.rolService.permisos.toString()
    if(this.permisosStr.includes('Supervisor Gestión de Fraudes')){
      this.openAprobarCasosSupervisor()
    }else if(this.permisosStr.includes('Gerente Gestión de Fraudes')){
      this.openAprobarCasosGerente()
    }
  }
  openAprobarCasosSupervisor(){
    this.router.navigate(['casos/revision-supervisor-deteccion-fraude']);
  }
  openAprobarCasosGerente(){
    this.router.navigate(['casos/revision-gerente-deteccion-fraude']);
  }
}

